import Api from "~/service/Api";

class UiMeet3dLinkPairRepository {
  create(locale, data) {
    return Api.post(`/${locale}/ui-meet-3d/link-pairs`, data);
  }

  update(locale, roomId, data) {
    return Api.put(`/${locale}/ui-meet-3d/link-pairs/${roomId}`, data);
  }

  delete(locale, roomId) {
    return Api.delete(`/${locale}/ui-meet-3d/link-pairs/${roomId}`);
  }
}

export default UiMeet3dLinkPairRepository;
